import Button from '../../../components/base/Button';

export default function ServicesHero() {
  const handleContactCall = () => {
    window.open('tel:+21620403150', '_self');
  };

  return (
    <section className="relative py-32 bg-gradient-to-br from-gray-900 via-red-900 to-black overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/37253c28bb36324d67faa34069cb556a.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-8 leading-tight">
            Nos <span className="text-red-500">Services</span> de Sécurité
          </h1>
          <p className="text-xl md:text-2xl mb-12 text-gray-200 leading-relaxed">
            De l'étude de vos besoins à la maintenance de vos équipements, 
            nous vous accompagnons à chaque étape de votre projet de sécurité. 
            Notre expertise technique et notre service client d'excellence font la différence.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <button 
              onClick={handleContactCall}
              className="whitespace-nowrap cursor-pointer font-semibold rounded-lg transition-all duration-200 flex items-center justify-center bg-red-600 text-white hover:bg-red-700 px-8 py-4 text-lg"
            >
              <i className="ri-phone-line mr-2"></i>
              Contactez-nous
            </button>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">15 Ans d'Expérience</h3>
              <p className="text-gray-300">Expertise reconnue en sécurité</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Équipe Certifiée</h3>
              <p className="text-gray-300">Techniciens qualifiés et formés</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Intervention 24/7</h3>
              <p className="text-gray-300">Support technique permanent</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
